var _rect, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 100",
    width: 320,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 22,
    height: 76,
    fill: "#111111"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 38,
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#111111",
    letterSpacing: 1
  }, "DATA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 64,
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#111111",
    letterSpacing: 1
  }, "CAPTURE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 90,
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#111111",
    letterSpacing: 1
  }, "SYSTEMS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcs);
export default __webpack_public_path__ + "static/media/dcs.ea6c4d0cdbe9cc93fcc849a71baea73d.svg";
export { ForwardRef as ReactComponent };